module.exports = __webpack_public_path__ + "media/img/illustrations/sticky-506a9e9bb4b9194c8afb5e3142935ab6.svg";